<!-- eslint-disable no-tabs -->
<template>
  <div>
    <div v-if="!isListLoading" class="panel-notification is-scroll" v-infinite-scroll="loadMore"
      infinite-scroll-throttle-delay="400" infinite-scroll-distance="10">
      <div>
        <div v-for="(group) in metricsGroup"
          :key="group.group_id"
          class="panel-list metrics-group">
          <h4 style="color: #24242f;" class="card-list-title">
            {{ group.header }}
          </h4>
          <ul>
            <li
              v-for="(metric) in group.metrics"
              :key="metric.id"
              class="metrics-box pointer"
              :style="{ 'border-left': '2px solid ' + metric.color }"
              :class="{ 'metrics-box-active': isSelectedLog(metric.id) }"
              @click="selectItem(metric)"
            >
              <div class="d-flex" style="justify-content: space-between;">
                <p>{{ metric.type }}</p>
                <div
                  style="width: 25px;"
                >
                  {{ (data && data[metric.countField]) || 0 }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="!metricsGroup.length && !isListLoading" class="status-msg my-sm" size="small" text="top-left"
      style="width:45%;">
      <div class="status-content">
        <span class="status-inner">
          <img :src="NoData" width="200" height="180" class="img-responsive" alt="" />
          <p style="width:100px; left:20px;">{{ $t('INDENT_NO_DATA_FOUND') }}</p>
        </span>
      </div>
    </div>
    <div v-if="isListLoading" class="status-msg my-md" style="width:45%;">
      <span>
        <img :src="LoaderCommon" width="240" class="img-responsive" alt="" />
      </span>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import NoData from '@common/asset/images/status-no-data.png';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoaderCommon from '@common/asset/images/loader-common.gif';


import { transactionTypes } from '@/constants/integrations';

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isListLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedItem: {},
      NoData,
      LoaderCommon,
      transactionTypes,
      metricsGroup: [],
    };
  },
  created() {
    this.getMetricsData();
    this.selectedItem = this.metricsGroup[0].metrics[0];
  },
  computed: {
    isSelectedLog() {
      return (id => !!((this.selectedItem && this.selectedItem.id) === id));
    },
  },
  methods: {
    loadMore() {
      this.$emit('load-more');
    },
    selectItem(item) {
      this.selectedItem = item;
      this.$emit('load-indent-list', this.selectedItem);
    },
    getRandomColor() {
      const hue = Math.floor(Math.random() * 360);         // Full color spectrum
      const saturation = Math.floor(Math.random() * 20) + 60; // 60%–80% saturation
      const lightness = Math.floor(Math.random() * 20) + 30; // 30%–50% lightness (medium-dark)
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    },
    getMetricsData() {
      this.metricsGroup = [{
        group_id: 1,
        header: 'Indent Status',
        metrics: [
          {
            id: 1,
            type: 'List of Indents in Indented',
            color: this.getRandomColor(),
            queryParams: 'status=indented',
            endPoint: 'order/filtered-indents',
            countField: 'indented',
          },
          {
            id: 2,
            type: 'List of Indents in Dispatched',
            color: this.getRandomColor(),
            queryParams: 'status=dispatched',
            endPoint: 'order/filtered-indents',
            countField: 'dispatched',
          },
          {
            id: 3,
            type: 'List of Indents in Delivery Pending',
            color: this.getRandomColor(),
            queryParams: 'status=delivery_pending',
            endPoint: 'order/filtered-indents',
            countField: 'delivery_pending',
          },
          {
            id: 4,
            type: 'List of Indents in Delivered',
            color: this.getRandomColor(),
            queryParams: 'status=delivered',
            endPoint: 'order/filtered-indents',
            countField: 'delivered',
          },
        ],
      }, {
        group_id: 2,
        header: 'Data Missing',
        metrics: [
          {
            id: 5,
            type: 'List of Indents without Proof Of Delivery',
            color: this.getRandomColor(),
            endPoint: 'order/indent-without-pod-attachment',
            countField: 'pod',
          },
          {
            id: 6,
            type: 'List of Indents without Lorry Receipt Number',
            color: this.getRandomColor(),
            endPoint: 'order/indent-without-lr-number',
            countField: 'lr',
          },
          {
            id: 7,
            type: 'List of Indents without Material Invoice Number',
            color: this.getRandomColor(),
            endPoint: 'order/indent-without-material-invoice',
            countField: 'material_invoice',
          },
        ],
      }, {
        group_id: 3,
        header: 'Breaches',
        metrics: [
          {
            id: 8,
            type: 'List of indents that has Acceptance SLA breach',
            color: this.getRandomColor(),
            queryParams: 'type=ACCEPTANCE',
            endPoint: 'order/breach-metrics',
            countField: 'acceptance',
          },
          {
            id: 9,
            type: 'List of indents that has Arrival SLA breach',
            color: this.getRandomColor(),
            queryParams: 'type=ARRIVAL',
            endPoint: 'order/breach-metrics',
            countField: 'arrival',
          },
        ],
      }];
    },
  },
};
</script>

<style scoped>
.panel-notification {
  width: 50%;
}

.panel-notification .metrics-box {
  background-color: rgba(255, 255, 255, 0.75);
  padding: 10px;
  font-size: 1.2rem;
  color: #404040;
  border-bottom: 1px solid #E9F1F5;
  margin-left: 10px;
  margin-top: 10px;
  /* border-left: 4px solid #3F6ABF; */
}

.metrics-box li {
  min-width: 109px;
  height: 70px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 14px 10px 10px 10px;
  position: relative;
  cursor: pointer;
}

.metrics-box p {
  margin: 0;
  font: 1.2rem / 14px "OpenSans-Semibold";
  /* color: #24242f; */
  text-transform: capitalize;
  /* margin-bottom: 5px; */
}

.metrics-box-active {
  background: linear-gradient(0deg, rgba(0, 118, 221, 0.1), rgba(0, 118, 221, 0.1)) !important;
}

.metrics-box .text-value {
  background: linear-gradient(360deg, #18283B -62%, #3F6ABF 104%);
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0) !important;
  font: 2.2rem / 20px "OpenSans-Bold";
}

.panel-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0;
  position: relative;
  z-index: 0;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.metrics-group {
  /* background-color: rgba(255, 255, 255, 0.75); */
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  padding: 10px;
  display: -ms-flexbox;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  font-size: 1.2rem;
  color: #404040;
  border: 1px solid #E9F1F5;
  margin-bottom: 10px;
}
</style>
